<div class="sa-review-page">
    <div class="container">
        <a (click)="downloadPdf()" id="download-pdf-link"><i class="sch-download"></i>PDF</a>
        <div class="print-content" id="print-review-page">
            <img id="print-logo" src="./static/assets/images/cs_logo-04.png" width="100" height="100">
            <span id="sa-review-page-header" class="section-title">
              Review
            </span>
            <mm-spinner [loading]="reviewPageComponentState$" [makeInert]="false"></mm-spinner>

            <!--Display Initiate and release non iso error when non iso sloa is released during iso ea/ga-->
            <!--All other error/warning banners can be skipped since the sloa is invalid and will require deletion-->
            <ng-container *ngIf="isNonIsoCompliantSloaReleasorFlow; else regularErrorBanner">
                <mm-banners id="invalid-non-iso-inr-error" [bannerText]="[nonIsoCompliantSloaInRError]" [type]="'error'"></mm-banners>
            </ng-container>
            <div *ngIf="hasAchWarningMessage">
                <mm-banners *ngFor="let achWarning of achWarningMessageList" [bannerText]="[achWarning.messageText]" [type]="'warning'" data-testid="sa_reviewPage_achWarning"></mm-banners>
            </div>
            <ng-template #regularErrorBanner>
                <ng-container *ngIf="(hasBadRequestServiceError || hasAtpTimeoutError)" class="no-print">
                    <div *ngIf="!isErrorSubmit">
                <mm-banners *ngFor="let error of serviceErrorList" [bannerText]="[error]"
                    [type]="'error'" id="sa_reviewPage_badRequestServiceError"
                            data-testid="sa_reviewPage_badRequestServiceError"></mm-banners>
                    </div>
                    <div *ngIf="isErrorSubmit">
                <mm-banners [bannerText]="[atpErrorOnSubmitToggleOnBannerMessage]" [titleText]="atpErrorOnSubmitToggleOnBannerTitleText" [shouldBoldTitleText]="true"
                            [routeRedirect]="errorLink" [type]="'warning'" id="sa_reviewPage_badRequestServiceError"
                            data-testid="sa_reviewPage_badRequestServiceError"></mm-banners>
                    </div>
                </ng-container>

                <mm-banners *ngIf="(formServiceError$ | async)?.hasError && !isErrorSubmit" class="hideSection"
                    [serviceError]="(formServiceError$ | async)!" [type]="'error'" id="sa_reviewPage_serviceError"
                    data-testid="sa_reviewPage_serviceError" [isInRFromTableDuplicateDraftsEnabled]="isInitiateAndReleaseFlowFromTable"></mm-banners>
                <mm-banners *ngIf="hasATSSystemError" class="hideSection" [bannerText]="[atsSystemErrorText]"
                    [type]="'error'"></mm-banners>
                <mm-error-summary *ngIf="(submitClicked$ | async) && (errors$ | async) && !isErrorSubmit"
                    class="hideSection" [errors]="[(errors$ | async)!]"
                    [summaryText]="errorSummaryText"></mm-error-summary>
                <mm-banners data-testid="reviewPage_attentionmessage" *ngIf="attentionMessageRequired"
                    [verifyAttentionMessage]="true" [stateTaxAttentionRequiredMI]="isStateTaxAttentionRequiredMI()"
                    [stateTaxAttentionRequiredCT]="isStateTaxAttentionRequiredCT()"
                    [stateTaxAttentionRequiredMN]="isStateTaxAttentionRequiredMN()"
                    [charitableMessage]="isCharitableContribution()" [warningMessages]="warningMessages"
                    [type]="'information'" id="reviewPage_attentionmessage"></mm-banners>

                <mm-banners id="single-revalidation-error" class="revalidation_error_warning" *ngIf="displayRevalidationError && multipleRevalidationError.length == 0" [bannerText]="[singleRevalidationError]" [type]="'error'"></mm-banners>
                <mm-banners id="multiple-revalidation-error" class="revalidation_error_warning" *ngIf="displayRevalidationError && multipleRevalidationError.length > 1" [useBulletedListDisplay]="true" [bannerText]="multipleRevalidationError" [type]="'error'"></mm-banners>
            </ng-template>

            <div id="sa_reviewPage_copy" class="sa-review-page-copy">
                <span>{{reviewPageCopy}}</span>
            </div>
            <mm-sa-transaction-review></mm-sa-transaction-review>
            <mm-client-authorization *ngIf="showClientAuthorization || useTestTrustDigitalToPdfFlow || isI401kToAccount"
                [eAuthRestricted]="eAuthRestricted" [eAuthIneligible]="eAuthIneligible"
                [standingAuthorizationsEAuth]="true" [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"
                [clientAuthorizationDetailsVerbiage]="isOrgAccount || isLivingTrustSaFlow ? 'One account holder must use ' : 'Select a client for '">
            </mm-client-authorization>
        </div>
        <mm-money-movement-acknowledgement-section
            *ngIf="!isInitiator && !isNonIsoCompliantSloaReleasorFlow"></mm-money-movement-acknowledgement-section>
        <button *ngIf="isEditEnabled" id="sa_reviewPage_editButton" type="button"
            class="small-button sdps-button sdps-button--small sdps-button--secondary" (click)="onEditClicked()" data-testid="sa_reviewPage_editButton"[disabled]="shouldButtonsBeDisabled">
            Edit
        </button>
        <button *ngIf="isBackButtonEnabled" id="sa_reviewPage_backButton" type="button" (click)="onBackButtonClicked()"
            class="small-button sdps-button sdps-button--small sdps-button--secondary" data-testid="sa_back_button">Back
        </button>
        <button *ngIf="!hasServiceErrorFORINRTable" id="sa_reviewPage_cancelButton"
            data-testid="sa_reviewPage_cancelButton" type="button" [disabled]="shouldButtonsBeDisabled"
            class="sdps-button sdps-button--small sdps-button--secondary" (click)="onCancelClicked()">
            {{cancelButtonVerbiage}}
        </button>
        <button *ngIf="!useTestTrustDigitalToPdfFlow && showSubmitButtonForInR && !isI401kToAccount" id="sa_reviewPage_submitButton"
            data-testid="sa_reviewPage_submitButton" type="button" [disabled]="shouldButtonsBeDisabled"
            class="sdps-button sdps-button--primary sdps-button--small" (click)="onSubmit()">
            {{submitButtonVerbiage}}
        </button>
         <button *ngIf="useTestTrustDigitalToPdfFlow || isI401kToAccount" id="sa_reviewPage_createPdfButton"
            data-testid="sa_reviewPage_createPdfButton" type="button"
            class="sdps-button sdps-button--primary sdps-button--small" (click)="onCreatePdf()">
            Create PDF
        </button>
        <mm-delete-initiated-draft-modal [showModal$]="deleteDraftClicked$.asObservable()" [currentDraft]="currentDraftInContext$.asObservable() | async" [isSloa]="true" [isFromReviewPage]="true"></mm-delete-initiated-draft-modal>
    </div>
</div>
